/* eslint-disable jsdoc/check-param-names */
/* eslint-disable jsdoc/check-types */
import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Stack,
  Button,
} from "@mui/material";
import { CreditCard } from "@material-ui/icons";

/**
 * A card component that displays a title and two buttons to create
 * a support and/or credit application.
 *
 * @param {function} onSupportClick - The function to call when the support
 * button is clicked.
 * @param {function} onCreditClick - The function to call when the credit
 * button is clicked.
 */
export default function FinanceApplicationsCard({ onSupportClick, onCreditClick }) {
  return (
    <Card elevation={2} sx={{ borderRadius: 3 }}>
      <CardContent sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", gap: 1, fontWeight: 600, mb: 3 }}>
          <CreditCard color="primary" />
          Finance Applications
        </Typography>
        
        <Stack spacing={2}>
          <Button
            variant="contained"
            fullWidth
            onClick={onSupportClick}
            sx={{ borderRadius: 2 }}
          >
            Create Support Application
          </Button>
          <Button
            variant="contained"
            fullWidth
            onClick={onCreditClick}
            sx={{ borderRadius: 2 }}
          >
            Create Credit Application
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
